import { useAppList } from "../../../hooks/useAppList.js";
import { AppItemMobile } from "./AppItemMobile.js";
import "react";
import { jsx } from "react/jsx-runtime";
// src/modules/AppWrapper2/components/AppNav/components/AppPickerMobile.tsx
function AppPickerMobile() {
	const { appList, currentApp } = useAppList();
	if (!appList.length) return null;
	return /* @__PURE__ */ jsx("div", {
		className: "gap-y-xs flex flex-col overflow-auto rounded-md",
		children: appList.map(({ description, icon, link, name }) => /* @__PURE__ */ jsx(AppItemMobile, {
			active: currentApp?.name === name,
			description,
			icon,
			link,
			name,
			onClick: () => {
				window.location.href = link;
			}
		}, link))
	});
}
export { AppPickerMobile };

//# sourceMappingURL=AppPickerMobile.js.map